import styled from 'styled-components';

export const Container = styled.div`
    width: 90%;
    max-width: 71.25rem; // 1140px 
    margin: 0 auto;
    /* outline: 1px solid rgba(255,0,0,.3); */
`;